// s98-comparison

import selfHtml from './s98-comparison.html' with { type: 'text' };;

var root

export async function init(module_root) {

    module_root.innerHTML = selfHtml;

    root = module_root;

    window.history.pushState({ page_id: 1, }, '', "./?compare");
    
}
